export default __webpack_public_path__ + "static/media/Logo.5e75da56.png";